import React from 'react';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';

const Deduction = ({ deductionList, setDeductionList, handleSDRefund, setTransectionData }) => {
    const { currencyPrecision } = useCurrency();
    const totalAmount = deductionList.reduce((sum, item) => sum + parseFloat(item.Exp2 || 0), 0)?.toFixed(currencyPrecision?.decimalNumbers);

    const handleChange = (index, key, value) => {
        const updatedList = [...deductionList];
        updatedList[index] = {
            ...updatedList[index],
            [key]: value,
        };

        // Recalculate Exp2 = Exp1 * Category
        const amount = parseFloat(updatedList[index].Exp1) || 0;
        const qty = parseFloat(updatedList[index].Category) || 0;
        updatedList[index].Exp2 = (amount * qty)
            .toFixed(currencyPrecision?.decimalNumbers || 2);

        setDeductionList(updatedList);
    };


    // Calculate total of Exp2

    return (
        <div className='gridshad mt-2 mb-3'>
            <div className='table-container' style={{ overflowX: 'auto', height: "auto" }}>
                <table>
                    <thead className='dynoTable'>
                        <tr>
                            <th>Description</th>
                            <th>Narration</th>
                            <th>Amount</th>
                            <th>Qty</th>
                            <th>Amt</th>
                            <th>Post</th>
                            <th>Select</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(deductionList) && deductionList.map((data, index) => (
                            <tr key={index}>
                                <td className='m-0 p-0'><input className='p-1' value={data?.Description} disabled style={{ width: "300px" }} /></td>
                                <td className='m-0 p-0'><input className='p-1' style={{ width: "230px" }} value={data?.Remarks === "0" ? "" : data?.Remarks}
                                    onChange={e => handleChange(index, 'Remarks', e.target.value)} />
                                </td>
                                <td className='m-0 p-0'><input className='p-1' type="number" style={{ width: "230px" }} value={data?.Exp1}
                                    onChange={e => handleChange(index, 'Exp1', e.target.value)} />
                                </td>
                                <td className='m-0 p-0'><input className='p-1' type="number" style={{ width: "200px" }} value={data?.Category}
                                    onChange={e => handleChange(index, 'Category', e.target.value)} />
                                </td>
                                <td className='m-0 p-0'><input className='p-1' type="text" value={data?.Exp2} disabled style={{ width: "200px" }} /></td>
                                <td className='m-0 p-0 text-center'>
                                    <input
                                        type="checkbox"
                                        checked={!!data?.Posting}
                                        onChange={e => handleChange(index, 'Posting', e.target.checked)}
                                        style={{ width: "20px", height: "20px" }}
                                    />
                                </td>

                                <td className='m-0 p-0 text-center'>
                                    <input
                                        type="checkbox"
                                        checked={data?.Exp3 === 1}
                                        onChange={e => handleChange(index, 'Exp3', e.target.checked ? 1 : 0)}
                                        style={{ width: "20px", height: "20px" }}
                                    />

                                </td>
                            </tr>
                        ))}

                        <tr>
                            <td colSpan="4" className='m-0 p-0'>
                                <input className='p-1 w-100' disabled value={"Total Amount"} />
                            </td>
                            <td>
                                <input style={{ width: "200px" }} className='p-1' type="text" disabled value={totalAmount} />
                            </td>
                            <td colSpan="2">
                                <input className='p-1 w-100' type="text" disabled value={""} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Deduction;
